<!-- eslint-disable vue/no-v-html -->
<script lang="ts">
import type { SetupContext } from 'vue';
import type { HekateDisplayField } from '@onshape/www-inertia';
import FieldErrorMessage from './FieldErrorMessage.vue';
import CoordinatorProvider from '../coordinator/CoordinatorProvider';

export default defineComponent({
  components: {
    FieldErrorMessage,
  },
  props: {
    field: {
      required: true,
      type: Object as unknown as () => HekateDisplayField,
    },
    modelValue: {
      required: true,
      type: String,
    },
  },
  emits: ['blur', 'focus', 'update:modelValue'],
  setup(props: { modelValue: string; field: HekateDisplayField }, context: SetupContext) {
    const { field, modelValue } = toRefs(props);
    return CoordinatorProvider.get().selectField({
      field,
      modelValue,
      context,
    });
  },
});
</script>

<template>
  <div
    :class="[
      'field-single-select',
      'field-container',
      'field-single-select-option-list-id-' + field.optionListId,
    ]"
  >
    <div
      :class="{
        'field-content': true,
        'field-content-is-validated': field.isValidated,
        'field-content-is-errored': field.errorMessages.length > 0,
      }"
    >
      <label :for="`${field.htmlName}-for-${field.id}`">
        <span v-html="$t(field.name, field.htmlName, field.label)" /><sup
          v-if="field.isRequired"
          class="required-indicator"
          title="This field is required"
          >*</sup
        >
      </label>
      <select
        :id="`${field.htmlName}-for-${field.id}`"
        v-model="bubbleModel"
        :html-name="field.htmlName"
        :required="field.isRequired"
        :disabled="field.isDisabled"
        @blur="$emit('blur', field)"
        @focus="$emit('focus', field)"
      >
        <component
          :is="option.getTemplateName()"
          v-for="(option, ii) in allOptions"
          :key="`option-${option.displayName}-${ii}`"
          :label="$t(option.displayName, option.value)"
          :value="option.value"
          >{{ $t(option.displayName, option.value) }}</component
        >
      </select>
    </div>
    <field-error-message :messages="field.errorMessages" />
  </div>
</template>

<style lang="scss" scoped>
.field-single-select {
  optgroup {
    color: #eee;
  }

  .field-content {
    display: flex;
    flex-direction: column;
    select {
      width: 100%;
    }
  }
}
</style>
